// games/buggies/boot.ts -- /buggies path matcher, shared by main.tsx dispatch
// and unit tests. Mirrors the per-game regex shape used for drift/rally/etc.:
// optional <locale>/ prefix, then "buggies", then "/" or end of string.
export const BUGGIES_PATH_RE = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?buggies(?:\/|$)/i;

export function isBuggiesPath(path: string): boolean {
  return BUGGIES_PATH_RE.test(path);
}
